import React, { memo } from "react";
import { Grid } from "@mui/material";

import NetworkVisualization from "../networkviz/networkViz";
import { GraphContext } from "../context";

const GraphDisplayComponent = ({
  nodes,
  edges,
  connection,
  traversingEdge,
}) => {
  const { graphOptions, setNodes, setEdges } = React.useContext(GraphContext);
  const { type } = graphOptions;
  const data = { nodes, edges };

  return (
    <Grid
      display={"flex"}
      flex={0.6}
      borderRight={2}
      borderColor={"black"}
      bgcolor={"#0f1629"}
    >
      {type === "Custom" ? (
        <NetworkVisualization
          data={data}
          connection={connection}
          chatType={type}
          setNodes={setNodes}
          setEdges={setEdges}
          traversingEdge={traversingEdge}
        />
      ) : (
        <NetworkVisualization
          data={data}
          connection={connection}
          traversingEdge={traversingEdge}
        />
      )}
    </Grid>
  );
};

export default memo(GraphDisplayComponent);
